module.exports = __webpack_public_path__ + "media/images/xpass/xpass-token-fallback-598de939dc8941526fc6aadd85500773.png";